<vdr-chip>
    <clr-icon [attr.shape]="getIcon(state)" class="state-icon" [ngClass]="state"></clr-icon>
    {{ state | titlecase }}
</vdr-chip>
